var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDelete = function SvgIcDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_delete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.973 8.027h-3.325v-1.33a.672.672 0 0 0-.665-.665h-3.99a.672.672 0 0 0-.665.665v1.33H8.003a.672.672 0 0 0-.665.665c0 .361.304.665.665.665h11.959a.672.672 0 0 0 .665-.665.672.672 0 0 0-.665-.665h.011Zm-7.303-.665h2.66v.665h-2.66v-.665ZM8.692 10.01v10.628c0 .735.595 1.33 1.33 1.33h7.968a1.33 1.33 0 0 0 1.33-1.33V10.01H8.692Zm3.325 9.298a.672.672 0 0 1-.665.665.672.672 0 0 1-.665-.665V12.67c0-.362.303-.665.665-.665.361 0 .665.303.665.665v6.638Zm2.66 0a.672.672 0 0 1-.665.665.672.672 0 0 1-.665-.665V12.67c0-.362.303-.665.665-.665.361 0 .665.303.665.665v6.638Zm2.66 0a.672.672 0 0 1-.665.665.672.672 0 0 1-.665-.665V12.67c0-.362.303-.665.665-.665.361 0 .665.303.665.665v6.638Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_delete_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgIcDelete;